const USERNAME_STORAGE_KEY = 'sportsWebsiteUsername';

const normalizeUsername = (value) => (typeof value === 'string' ? value.trim() : '');

export const getStoredUsername = () => {
  if (typeof window === 'undefined') {
    return '';
  }

  try {
    return normalizeUsername(window.localStorage.getItem(USERNAME_STORAGE_KEY) || '');
  } catch (error) {
    console.error('Error reading stored username:', error);
    return '';
  }
};

export const saveStoredUsername = (value) => {
  const username = normalizeUsername(value);

  if (!username || typeof window === 'undefined') {
    return '';
  }

  try {
    window.localStorage.setItem(USERNAME_STORAGE_KEY, username);
  } catch (error) {
    console.error('Error saving stored username:', error);
  }

  return username;
};

export const clearStoredUsername = () => {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    window.localStorage.removeItem(USERNAME_STORAGE_KEY);
  } catch (error) {
    console.error('Error clearing stored username:', error);
  }
};